/* eslint-disable prefer-destructuring, no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { spellOutSounds } from '@/utils/sounds';
import { DEVICE } from '@/constants';
import { OS } from '@/utils/detectDevice';
import Bubble from '@/assets/images/exercises/spellOut/bubble.png';
import { BallBox, Ball } from './collision.js';
import './style.less';

class SpellOut extends React.Component {
  static propTypes = {
    finished: PropTypes.func,
    exercisesData: PropTypes.object,
    retryBtn: PropTypes.func,
    url: PropTypes.string,
    audioStop: PropTypes.func,
    audioPlay: PropTypes.func,
    changeBtn: PropTypes.func,
    soundsUrl: PropTypes.string,
  };

  constructor() {
    super();
    this.state = {
      word: '',
      index: 0,
      audio: '',
      spellOutData: null,
      playing: '',
      redoDis: true,
      btnDisplay: false,
      redoDisplay: true,
    };
  }

  componentDidMount() {
    const { exercisesData, url } = this.props;
    this.init(exercisesData, url);
  }

  componentWillReceiveProps(nextProps) {
    nextProps.url !== this.props.url && this.init(nextProps.exercisesData, nextProps.url);
  }

  init = (exercisesData, url) => {
    const task = exercisesData.root[0].tasks[0].task;
    const Data = [];
    task.forEach((item) => {
      Data.push({
        audio: `${url}OM/${item._attr.audio._value}.ogg`,
        txt: item._attr.name._value,
      });
    });
    this.setState({
      spellOutData: Data,
    });
  }

  rand =(m, n) => {
    const val = m + parseInt((n - m) * Math.random(), 10);
    return val;
  }

  handleClick = (word, audio, i) => {
    this.setState({
      word,
      audio,
      index: i,
      redoDis: true,
      btnDisplay: true,
      redoDisplay: true,
    });
    const lw = document.getElementById('letterWrapper');
    const oC = document.getElementById('bubbleContainer');
    document.querySelectorAll('.ball').forEach((item) => {
      oC.removeChild(item);
    });
    lw.innerHTML = '';
    lw.style.display = 'block';
    const mxwidth = oC.offsetWidth;
    const mxheight = oC.offsetHeight;
    const oB = new BallBox('bubbleContainer');
    oB.ballRun();
    word.split('').forEach((item, index) => {
      const lwChild = document.createElement('div');
      lwChild.id = `letter${index + 1}`;
      lw.appendChild(lwChild);
      this.props.retryBtn(false);
      const b = mxwidth > 415 ? this.rand(50, 75) : this.rand(40, 55);
      const x = this.rand(b, mxwidth - b);
      const y = this.rand(b, mxheight - b);
      const ball = new Ball({
        b,
        x,
        y,
        sx: this.rand(1, 5),
        sy: this.rand(1, 5),
        c: `url(${Bubble})`,
        html: item,
        class: 'ball',
        callBack: (type) => {
          type === 'redo' && this.setState({ redoDis: false });
          type === 'mouseup' && this.handleMouseup(type);
          type === 'playSounds' && this.handleSounds(spellOutSounds.handle);
        },
      });
      oB.addBall(ball);
    });
  }

  handleSounds = (src) => {
    const { soundsUrl } = this.props;
    this.props.audioPlay(`${soundsUrl}${src}`, { type: 'exercise' });
    OS.TYPE === DEVICE.PC && this.audioEnd();
  }

  handleMouseup = () => {
    const lw = document.getElementById('letterWrapper');
    const answer = document.querySelector('.answer');
    let word = '';
    lw.childNodes.forEach((item) => {
      const dv = item;
      word += dv.innerText;
      dv.innerText = '';
      dv.className = '';
    });
    const result = document.createElement('div');
    result.innerText = word;
    if (word === this.state.word) {
      answer.appendChild(result);
      // redo消失
      this.setState({ redoDis: true, redoDisplay: false });
      this.props.changeBtn(false);
      document.getElementById(`question${this.state.index}`).style.display = 'none';
      if (answer.childNodes.length === this.state.spellOutData.length) {
        this.handleSounds(spellOutSounds.allRight);
        this.setState({ btnDisplay: false });
        this.props.finished();
        this.props.retryBtn(true);
        lw.style.display = 'none';
      }
    } else {
      this.handleRedo();
    }
  }

  handleRedo = () => {
    this.handleClick(this.state.word, this.state.audio, this.state.index);
  }

  handlePlay = () => {
    const { playing, audio } = this.state;
    !playing ? this.props.audioPlay(audio, { type: 'exercise' }) : this.props.audioStop();
  }

  handleRetry = () => {
    this.props.retryBtn(false);
    const { exercisesData, url } = this.props;
    this.setState({ spellOutData: null }, () => {
      const oC = document.getElementById('bubbleContainer');
      oC.innerHTML = '<div class=\'answer\' />';
    });
    document.querySelectorAll('.question-num').forEach((item) => {
      const questionNum = item;
      questionNum.style.display = 'block';
    });
    const lw = document.getElementById('letterWrapper');
    lw.innerHTML = '';
    lw.style.display = 'none';
    this.init(exercisesData, url);
  }

  audioEnd = () => this.setState({ playing: false });

  audioPlay = () => this.setState({ playing: true });

  render() {
    const {
      spellOutData,
      playing,
      redoDis,
      redoDisplay,
      btnDisplay,
    } = this.state;
    return (
      <div className="spell-out-container">
        <div className="spell-out-question-wrapper">
          {
            spellOutData && spellOutData.map((item, index) => (
              <div className="question-num" key={`question${index + 1}`} id={`question${index}`} data-finish="false" onClick={() => { this.handleClick(item.txt, item.audio, index); }}>
                {index + 1}
              </div>
            ))
          }
        </div>
        <div className="bubble-container" id="bubbleContainer">
          <div className="answer" />
        </div>
        <div className="letter-wrapper" id="letterWrapper" data-val={this.state.word} />
        <div className="snow1" />
        <div className="snow2" />
        <div className="snow3" />
        <div className="snow4" />
        {btnDisplay
          ? (
            <div className="spell-out-btn">
              <div className={`spell-out-play${playing ? ' playing' : ''}`} onClick={this.handlePlay} />
              {redoDisplay && <div className={`spell-redo${redoDis ? ' disabled' : ''}`} onClick={!redoDis ? this.handleRedo : null}>Redo</div>}
            </div>
          )
          : null
        }
      </div>
    );
  }
}

export default SpellOut;
